<template>
  <div v-if="cartBoxBanner.desktopImage" class="text-center mb-0 mb-md-3 px-2 px-md-0">
    <a :href="cartBoxBanner.url" class="cartbox-banner js-cartbox-banner px-2 pt-3 pb-2">
      <img :src="`${cartBoxBanner.desktopImage}`" :alt="cartBoxBanner.title" class="img-fluid lazyload d-none d-md-block" />
      <img :src="`${cartBoxBanner.mobileImage}`" :alt="cartBoxBanner.title" class="img-fluid lazyload d-md-none" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    cartBoxBanner: {
      type: Object,
      required: true,
    },
  }
}
</script>
